var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"FceY5alpFN0zVa35J_q8X"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["vnda-partners-app@olist"]={id:"FceY5alpFN0zVa35J_q8X"};
      